import React from 'react';
import { GenericSkeleton } from '@landr/maestro';
import { UppercaseHeading } from './styled';

const Byline = ({
    content,
    isLoading,
    isVertical,
}: {
    content?: string;
    isLoading: boolean;
    isVertical: boolean;
}) => {
    const size = isVertical ? 'sm' : 'md';
    const height = isVertical ? '12px' : '14px';

    if (isLoading) {
        return <GenericSkeleton width="88px" height={height} mt={4} mb={18} />;
    }

    return (
        <UppercaseHeading as="h3" size={size} mb="xxs" nbOfLines={1}>
            {content}
        </UppercaseHeading>
    );
};

export default Byline;
